<template>
    <div>
        <div role="presentation" class="px-2">
            <div v-show="showDebitos">
                <h1 id="descricao-debito" aria-label="Parcelas da dívida." tabindex="-1"></h1>
                <h3 class="text-center" v-if="table.dividas.length == 0">Acesse a opção de Acordos para emissão de boletos
                </h3>
                <table v-else id="tabela" tabindex="-1" role="table" aria-label="Tabela de débitos."
                    class="table table-hover table-bordered  table-contrast">
                    <thead class="thead bg-thead table-contrast">
                        <tr role="row">
                            <th role="columnheader" class="text-left acessibilidade" style="">Contrato</th>
                            <th role="columnheader" class="text-left acessibilidade" style=""> Credor</th>
                            <th role="columnheader" class="text-left acessibilidade" style=""> Valor da Dívida</th>
                            <th role="columnheader" class="text-left acessibilidade"></th>
                        </tr>
                    </thead>
                    <tbody style="">
                        <tr v-for="(item, i) in table.dividas" :key="i" role="row">
                            <td role="cell" class="acessibilidade" style="width:30%; ">{{ item.CdContrato }}</td>
                            <td role="cell" class="acessibilidade" style="width:30%; border-right:0 ">{{ item.Credor.Nome }}
                            </td>
                            <td role="cell" class="acessibilidade" style="width:10%">R$ {{ item.ValorPrincipal }}</td>
                            <td role="cell" style="width:10%; border-left:0 " class="text-sm-center teste ">
                                <button type="button" @click="negociar(item)" class="btn bg-dark_white px-2 py-1"
                                    style="color: #292626 ">Negociar</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="!showDebitos && divida !== undefined">
                <NegociacaoUnimedBelem v-if="divida.Credor.TpCredor == 38" :divida="divida"></NegociacaoUnimedBelem>
                <NegociacaoPagSeguro v-else-if="divida.Credor.TpCredor == 46" :divida="divida"></NegociacaoPagSeguro>
                <Negociacao v-else :divida="divida"></Negociacao>
            </div>
        </div>
        <Carregando role="alert" id="carregando"></Carregando>
    </div>
</template>
<script>
import Vuex from '@/vuex/store'
import bus from '@/service/bus'
import Carregando from './MyComponents/Carregando'
import Negociacao from './Negociacao'
import NegociacaoUnimedBelem from './NegociacaoUnimedBelem'
import NegociacaoPagSeguro from './NegociacaoPagSeguro'
import { getDividas } from '@/service/service_autoatendimento/autoatendimento'
import { getParcelasPagSeguro } from '@/service/service_autoatendimento/autoatendimento'

export default {
    components: { Negociacao, Carregando, NegociacaoUnimedBelem, NegociacaoPagSeguro },
    data() {
        return {
            // telaGrande: false,
            table: {
                pagination: {
                    rowsPerPage: 5,
                    totalITems: '',
                    page: 1
                },
                headers: [
                    { text: 'Contrato', value: 'contrato' },
                    { text: 'Credor', value: 'credor' },
                    { text: '', value: 'btn', align: 'left', sortable: false, width: '10%' }
                ],
                dividas: []
            },
            showDebitos: true,
            // pessoa: {},
            divida: undefined
            // divida: undefined
        }
    },
    mounted() {
        window.fonte('debitos')
        this.carregaDividas()
        this.table.pagination.totalITems = this.table.dividas.length
        if (window.innerWidth >= 750) Vuex.commit('SET_TELA', true)

        window.onresize = () => {
            if (window.innerWidth >= 750) Vuex.commit('SET_TELA', true)
            else Vuex.commit('SET_TELA', false)
        }
        let d = document.getElementById('descricao-debito')
        d.focus()

    },
    methods: {
        carregaDividas() {
            // try {
            bus.$emit('load-in', { text: 'Um momento estamos carregados as informações dos contratos' })
            if (Vuex.state.dividas.length == 0) {
                var cpfcnpj = sessionStorage.getItem('user_codigo')
                getDividas(cpfcnpj).then(response => {
                    // this.pessoa = response.data.Retorno.Pessoa
                    for (let i in response.data.Retorno.Dividas) {
                        if (response.data.Retorno.Dividas[i].NegociacaoPermitida) {
                            if (response.data.Retorno.Dividas[i].Credor.TpCredor == 46) {

                                getParcelasPagSeguro(response.data.Retorno.Dividas[i].ChaveDivida).then((div) => {
                                    let pos = div.data.Retorno
                                    let soma = pos.reduce((total, item) => {
                                        return total + item.SaldoLiquidacao;
                                    }, 0)
                                    response.data.Retorno.Dividas[i].ValorPrincipal = soma
                                    if(i == 0){
                                        bus.$emit('load-out')
                                        
                                    }
                                }).catch(() => {
                                    bus.$emit('load-out')
                                })
                            } else {
                                bus.$emit('load-out')
                            }
                            this.table.dividas.push(response.data.Retorno.Dividas[i])
                        }
                    }
   

                    Vuex.commit('SET_DIVIDAS', this.table.dividas)
                }).catch(() => {
                    bus.$emit('load-out')
                })
            } else {
                bus.$emit('load-out')
                this.table.dividas = Vuex.state.dividas
            }

            // } catch (err) {
            //     bus.$emit('load-out')
            //     console.log(err)
            // }
        },
        negociar(item) {
            this.divida = item
            this.showDebitos = false
        }
    },
    computed: {
        pages() {
            if (this.table.pagination.rowsPerPage == null || this.table.pagination.totalITems == null) return 0
            return Math.ceil(this.table.pagination.totalITems / this.table.pagination.rowsPerPage)
        },
        telaGrande() {
            return Vuex.state.large
        }
    }
}
</script>